// extracted by mini-css-extract-plugin
export default {"cta":"SH-z","disabled":"TH-z"};